import axios from "axios";

var myAxios = axios.create({
  baseURL: "https://api.bibahobangla.com", // Production
  // baseURL: "http://192.168.68.105:5555", // Local development
});

// Add a request interceptor to attach fresh token on each request
myAxios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const uid = localStorage.getItem("id");

    if (token) {
      config.headers.token = token;
    }
    if (uid) {
      config.headers.uid = uid;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle 401 errors globally
myAxios.interceptors.response.use(
  (response) => {
    // Return successful responses as-is
    return response;
  },
  (error) => {
    // Check if error is 401 Unauthorized
    if (error.response && error.response.status === 401) {
      console.warn("401 Unauthorized - Token invalid or expired. Logging out...");

      // Clear all authentication data
      localStorage.removeItem("token");
      localStorage.removeItem("id");
      localStorage.removeItem("IsAdmin");
      localStorage.removeItem("AdminType");

      // Redirect to login page
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

export default myAxios;
